import React from 'react';
import { RouteComponentProps, navigate } from '@gatsbyjs/reach-router';
import useIntercom from '~/hooks/useIntercom';
import useIsMounted from '~/hooks/useIsMounted';
import useSessionHydration from '~/hooks/useSessionHydration';
import ChangeOrUpdateSubscription from '../ChangeOrUpdateSubscription';
import { AUTH_PATHS } from '~/components/page/Auth/constants';
import Button from '~/components/atom/Button';
import AccountSwitcher from '~/components/organism/AccountSwitcher';
import JustificationContainer from '~/components/atom/JustificationContainer';
import Portal from '~/components/molecule/Portal';
import styled, { css } from 'styled-components';

const SetupSubscriptionPage: React.FCC<RouteComponentProps> = () => {
  const isMounted = useIsMounted();
  const [, refetchSessionHydration] = useSessionHydration();
  const intercom = useIntercom();

  return (
    <>
      <ChangeOrUpdateSubscription
        onComplete={async () => {
          intercom.update({
            first_admin: true,
            signed_up_at: new Date().getTime() * 1000,
          });

          await refetchSessionHydration();
          if (isMounted()) {
            void navigate('/-/onboarding');
          }
        }}
        accountIsSetup={false}
      />
      <Portal root="setup-subscription-toolbar">
        <Container gap="xs" align="center">
          <AccountSwitcher
            variant="button"
            appearance="primary"
            hideWhenSingleAccount
            withLogoutOption={false}
          />
          <Button
            icon="sign-out"
            ghost
            onClick={() => window.location.replace(AUTH_PATHS.LOGOUT)}
          />
        </Container>
      </Portal>
    </>
  );
};

const Container = styled(JustificationContainer)(
  ({ theme }) => css`
    position: absolute;
    display: flex;
    justify-content: space-between;
    align-items: center;
    top: ${theme.space('base')};
    right: ${theme.space('base')};
  `,
);

export default SetupSubscriptionPage;
